import React, { useState } from 'react'
import clsx from 'clsx'
import './navbar.scss'
import { Link } from 'gatsby'
import logo from '../../images/ca-consumer-law-logo.png'
import { Icon } from '../Icon'
import { Button } from '../Button'
import { hideBodyScroll, showBodyScroll } from '../../utils/helpers'
export const Navbar = ({
  otherClasses,
  props,
  toggleFunc,
  profile,
  practiceAreas,
}) => {
  const [scroll, setScroll] = useState(false)

  const changeBackground = () => {
    if (typeof window !== 'undefined' && window.scrollY >= 40) {
      setScroll(true)
    } else {
      setScroll(false)
    }
  }
  typeof window !== 'undefined' &&
    window.addEventListener('scroll', changeBackground)

  const [toggle, setToggle] = useState(false)
  const toggleFunction = (elm) => {
    setToggle(!elm)
  }

  const navbarClasses = clsx(
    otherClasses,
    'fixed top-0 translate-x-[-50%] left-2/4 z-50 w-full py-3 lg:py-0 transition',
    props ? 'bg-transparent' : 'bg-primary_blue_800',
    scroll && 'bg-primary_blue_800',
    toggle && 'bg-primary_blue_800'
  )

  if (toggle) {
    hideBodyScroll()
  } else {
    showBodyScroll()
  }

  let orderArr = ['Lemon Law', 'Auto Fraud', 'Mediation']

  let orderedNodes = orderArr.map((item) =>
    practiceAreas.find(({ title }) => title === item)
  )

  return (
    <nav className={navbarClasses} id="navbar" data-testid="navbar">
      <div className="max-w-[1512px] mx-auto w-full px-6 flex justify-between items-center">
        <div className="flex items-center gap-8">
          <button className="lg:hidden" onClick={() => toggleFunction(toggle)}>
            <Icon
              icon={toggle ? 'cancel-icon' : 'hamburger-menu'}
              iconHeight={toggle ? 14 : 24}
              iconWidth={toggle ? 14 : 24}
            />
          </button>
          <Link to="/">
            <img
              src={logo}
              alt="logo"
              className="w-[170px] lg:w-[240px] xl:w-[273px] h-[36px] lg:h-[50px] xl:h-[56px]"
            />
          </Link>
          <div
            className={clsx(
              'absolute px-9  py-10 lg:py-0 lg:px-0 w-full lg:w-auto top-[60px] left-0  lg:static bg-primary_blue_700 lg:bg-transparent mobile_menu',
              toggle ? 'block' : 'hidden lg:block'
            )}
          >
            <ul
              className={clsx(
                'flex flex-col items-start  border-white/40 lg:flex-row  gap-6 xl:gap-8 lg:w-auto w-full border-b pb-[28px] lg:pb-0 lg:border-b-0',
                toggle && ''
              )}
            >
              <li className="lg:h-[88px] relative lg:flex flex-col lg:flex-row lg:items-center lg:w-auto gap-6 lg:gap-0 w-full group">
                <Link
                  to="/practice-areas"
                  className="text-sm leading-[30px] flex justify-between items-center lg:text-base cursor-pointer font-Work_Sans text-white font-semibold lg:text-left text-left group"
                >
                  Practice Areas{' '}
                  <span className="lg:hidden group-hover:rotate-180">
                    <Icon icon="angle" iconHeight={6} iconWidth={12} />
                  </span>
                </Link>

                <div className="group-hover:flex rounded-[10px] drop_shadow hidden flex-col gap-3 lg:absolute top-[70px] left-0 lg:py-[8px] lg:px-[16px] lg:bg-primary_blue_600 min-w-[260px] ">
                  <Link
                    to="/practice-areas"
                    className="text-sm pl-2 lg:pl-0 leading-7 lg:hidden mt-6 hover:text-[#FF9D00] font-Work_Sans text-white lg:font-semibold lg:text-left text-left"
                  >
                    Practice Areas Hub
                  </Link>
                  {orderedNodes.map(({ title, slug: { current } }, index) => {
                    return (
                      <Link
                        key={index}
                        to={`/${current}`}
                        className="text-sm pl-2 lg:pl-0 lg:text-base leading-7 lg:leading-6 hover:text-[#FF9D00] font-Work_Sans text-white lg:font-semibold lg:text-left text-left"
                      >
                        {title}
                      </Link>
                    )
                  })}
                </div>
              </li>
              <li className="lg:h-[88px] relative flex flex-col lg:flex-row lg:items-center lg:w-auto gap-6 lg:gap-0 w-full group">
                <Link className="text-sm leading-[30px] flex justify-between items-center lg:text-base lg:leading-6 font-Work_Sans text-white font-semibold lg:text-left text-left group">
                  About{' '}
                  <span className="lg:hidden group-hover:rotate-180">
                    <Icon icon="angle" iconHeight={6} iconWidth={12} />
                  </span>
                </Link>
                <div className="group-hover:flex hidden flex-col rounded-[10px] drop_shadow gap-3 lg:absolute top-[70px] left-0 lg:py-[8px] lg:px-[16px] lg:bg-primary_blue_600 min-w-[260px] ">
                  <Link
                    to="/about-us"
                    className="text-sm pl-2 lg:pl-0 lg:text-base leading-7 lg:leading-6 font-Work_Sans hover:text-[#FF9D00] text-white lg:font-semibold lg:text-left text-left"
                  >
                    About Us
                  </Link>
                  {profile.map(({ title, slug: { current } }) => {
                    return (
                      <Link
                        to={`/${current}`}
                        className="text-sm pl-2 lg:pl-0 lg:text-base leading-7 lg:leading-6 font-Work_Sans hover:text-[#FF9D00] text-white lg:font-semibold lg:text-left text-left"
                      >
                        {title}
                      </Link>
                    )
                  })}

                  <Link
                    to="/areas-we-serve"
                    className="text-sm pl-2 lg:pl-0 lg:text-base leading-7 lg:leading-6 font-Work_Sans hover:text-[#FF9D00] text-white lg:font-semibold lg:text-left text-left"
                  >
                    CA Areas Served
                  </Link>
                </div>
              </li>
              <li className="lg:h-[88px] relative flex flex-col lg:flex-row lg:items-center lg:w-auto gap-6 lg:gap-0 w-full group">
                <Link className="text-sm leading-[30px] flex justify-between items-center lg:text-base lg:leading-6 font-Work_Sans text-white font-semibold lg:text-left text-left group">
                  Resources{' '}
                  <span className="lg:hidden group-hover:rotate-180">
                    <Icon icon="angle" iconHeight={6} iconWidth={12} />
                  </span>
                </Link>
                <div className="group-hover:flex hidden flex-col rounded-[10px] drop_shadow gap-3 lg:absolute top-[70px] left-0 lg:py-[8px] lg:px-[16px] lg:bg-primary_blue_600 min-w-[260px] ">
                  <Link
                    to="/testimonials"
                    className="text-sm pl-2 lg:pl-0 lg:text-base leading-7 lg:leading-6 font-Work_Sans hover:text-[#FF9D00] text-white lg:font-semibold lg:text-left text-left"
                  >
                    Testimonials
                  </Link>
                  <Link
                    to="/blog"
                    className="text-sm pl-2 lg:pl-0 lg:text-base leading-7 lg:leading-6 font-Work_Sans hover:text-[#FF9D00] text-white lg:font-semibold lg:text-left text-left"
                  >
                    Blog
                  </Link>
                  <Link
                    to="/faqs"
                    className="text-sm pl-2 lg:pl-0 lg:text-base leading-7 lg:leading-6 font-Work_Sans hover:text-[#FF9D00] text-white lg:font-semibold lg:text-left text-left"
                  >
                    FAQs
                  </Link>
                </div>
              </li>
            </ul>
            <Button
              label="Contact"
              variant="primary"
              otherClasses={clsx(
                'block lg:hidden py-[12px] px-[32px] mt-[24px]'
              )}
              onClick={() => toggleFunc('Contact Us')}
            />
          </div>
        </div>
        <div className="hidden lg:flex items-center gap-6 xl:gap-8">
          <a
            href="tel:6194361826"
            className="flex items-center text-base font-semibold font-Work_Sans leading-6 text-white gap-2"
          >
            <Icon
              icon="navbar-phone-outline-icon"
              iconHeight={24}
              iconWidth={24}
            />
            619-436-1826
          </a>
          <Button
            variant="primary"
            label="Free Consultation"
            onClick={() => toggleFunc('Contact Us')}
          />
        </div>
        <a
          href="tel:6194361826"
          className="p-2 rounded-full bg-accent_orange_600 lg:hidden"
        >
          <Icon
            icon="navbar-mobile-outline-white-phone-icon"
            iconHeight={18}
            iconWidth={18}
          />
        </a>
      </div>
    </nav>
  )
}

export default Navbar
